<template>
  <div class="flex flex-col">
    <p
      class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6">
      Other Personal Information</p>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Are you a U.S. Resident?" fieldId="us_resident" v-model="form.us_resident" :required="false" :options="yesNoOptions"/>
        <ComboBoxControl label="Are you a U.S. Citizen?" fieldId="us_citizen" v-model="form.us_citizen" :required="false" :options="yesNoOptions"/>
        <TextControl ref="us_tin" is_num label="U.S. TIN (Mandatory for U.S. Resident/Citizen)" fieldId="us_tin" :required="false" v-model="form.us_tin"/>
        <TextControl ref="country_resident" label="Country/ies of Resident" fieldId="country_resident" :required="false" v-model="form.country_resident"/>
    </div>
    
    <p class="text-base lg:text-lg text-grey-darker mt-4 lg:mt-8 font-bold">Do you or any of your family members hold a public/government position in the:</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4 mt-3 lg:mt-6">
        <TextControl ref="name_pep" label="Name of PEP" fieldId="name_pep" :required="false" v-model="form.name_pep"/>
        <TextControl ref="person_pep" label="Position" fieldId="person_pep" :required="false" v-model="form.person_pep"/>
    </div>

    <div class="mt-8 xl:mt-16 flex flex-row gap-2 lg:gap-4">
            <ButtonControl theme="bg-white border-2 border-theme-primary text-theme-primary" rounded button_text="Back" @click="$emit('back')"/>
            <ButtonControl theme="bg-primary border-2 border-theme-primary text-white" rounded button_text="Next" @click="$emit('next')"/>
      </div>

  </div>
</template>

<script>
import TextControl from '@/components/controls/TextControl.vue';
import ComboBoxControl from '@/components/controls/ComboBoxControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';

import User from '@/services/User';
import mixin from '@/mixin';

export default {
  name: 'v-tab-2',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
        validationErrors: {},
        yesNoOptions: [
            { label: 'YES', value: 1 },
            { label: 'NO', value: 0 }
        ],
        form: {
          us_resident: "",
          us_citizen: "",
          us_tin: "",
          country_resident: "",
          name_pep: "",
          person_pep: ""

        }
    };
  },
  components: {
    TextControl,
    ComboBoxControl,
    ButtonControl
  },
  mounted() {
    this.$store.commit('setFormDataRCBC', this.form);
    this.restoreFormFromStore();
  },
  watch: {
    form: {
      handler(newForm) {
        this.$store.commit('setFormDataRCBC', newForm);
      },
      deep: true
    }
  },
  computed: {
    
  },
  methods: {
    restoreFormFromStore() {
      const storeFormData = this.$store.state.formDataRCBC || {};

      Object.keys(this.form).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(storeFormData, key) && storeFormData[key] !== undefined && storeFormData[key] !== null) {
          this.form[key] = storeFormData[key];
        }
      });
    },
    isTabComplete() {
      return this.tabCompletion;
    },
    updateValidation(field, isValid) {
      this.validationErrors[field] = isValid;
    },
  },
};
</script>

<style scoped>
.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.box {
  width: 4rem !important;
  height: 4rem !important;
  margin-right: 3rem !important; 
}
@media (max-width: 1000px) {
    .box {
      width: 2rem !important;
      height: 2rem !important;
      margin-right: 1rem !important;
      font-size:  5rem !important;
    }
    .agree {
      font-size: 1.7rem !important; 
    }
   

}

</style>